<div class="modal-header">
    <h4 class="modal-title pull-left">{{modalHeaderText}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModalHide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <label class="form-label">Guarantor<span class="star">*</span></label>
        <input class="form-control" #name="ngModel" maxlength="100" [(ngModel)]="guarantor.Name" required type="text">
        <p class="redtext" *ngIf="(Validation.IsinValid(guarantor.Name) && isSubmit) ||(name.invalid && name.touched)">Guarantor Name is required </p>
    </div>
    <div class="form-group">
        <label class="form-label">URL</label>
        <input class="form-control" #URL="ngModel" maxlength="500" [(ngModel)]="guarantor.URL" type="text">
        <p class="redtext" *ngIf="!Validation.IsinValid(guarantor.URL) && !URLValid && isSubmit">Website is not valid</p>
    </div>
    <div class="form-group">
        <label class="form-label">S&amp;P Rating</label>
        <label class="select">
            <select [(ngModel)]="guarantor.SPRatingId" class="form-control ">
                <option [value]="0">Select</option>
                <option *ngFor="let item of sprRatingList" [(ngValue)]="item.id">{{item.description}}</option>
            </select>
            <i></i>
        </label>
    </div>
    <div class="form-group">
        <label class="form-label">Moody's Rating</label>
        <label class="select">
            <select [(ngModel)]="guarantor.MoodyRatingId"
                    class="form-control ">
                <option [value]="0">Select</option>
                <option *ngFor="let item of moodysRatingList" [(ngValue)]="item.id">{{item.description}}</option>
            </select>
            <i></i>
        </label>
    </div>
    <div class="form-group">
        <label class="form-label">Fitch Rating</label>
        <label class="select">
            <select [(ngModel)]="guarantor.FitchRatingId"
                    class="form-control">
                <option [value]="0">Select</option>
                <option *ngFor="let item of fitchRatingList" [(ngValue)]="item.id">{{item.description}}</option>
            </select>
            <i></i>
        </label>
    </div>
    <!--<div class="form-group">
        <p class="redtext" *ngIf="((guarantor.SPRatingId == 0 && guarantor.MoodyRatingId == 0 && guarantor.FitchRatingId == 0) && isSubmit)">Please select atleast 1 rating </p>
    </div>-->
    <div class="text-right">
        <button class="btn btn-default btn-lg" id="closeModal" (click)="closeModalHide()">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="saveGuarantor();">Save</button>
    </div>
</div>
